// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"542":"b644cc9e","781":"182a9706","821":"7b3b2b1a"}[chunkId] + ".chunk.js";
};